import React from "react";
import { useDispatch } from "react-redux";

import { BsBookmarkStarFill } from "react-icons/bs";

import {
  MdOutlineCheckBox,
  MdOutlineCheckBoxOutlineBlank,
} from "react-icons/md";

import { WatchlistAction } from "../../store/actions";
import { Images } from "../../config";

import "./styles.css";
import { Link } from "react-router-dom";

const RecommenderTable = (props) => {
  const dispatch = useDispatch();

  const uniData = props?.items;

  const handleUniversityWishlist = (id) => {
    const payload = { id };
    dispatch(
      WatchlistAction.addOrRemoveToWishlist(payload, () => {
        dispatch(WatchlistAction.getWatchlist({}));
      })
    );
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="recommender-table-header">
        <div>Name</div>
        <div className="text-center">QS World Ranking</div>
        <div className="text-center">Average Fee</div>
        <div></div>
      </div>
      {uniData?.map((item, index) => (
        <div className="recommender-table-row" key={index}>
          <div className="flex gap-2">
            <div className=" pr-3 border-r-[0.125em] border-r-liteBoxBorder min-w-[4.0625em] flex items-center justify-center">
              <img
                src={item?.profilePic ?? Images.LogoIconOnly}
                className="h-[3em] w-[3em] rounded-full object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = Images.LogoIconOnly;
                }}
              />
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold">{item?.name}</div>
              <div className="flex gap-2 items-center">
                <img src={Images.LocationPin} className="h-[1.125em]" />
                <div className="font-semibold">
                  {item?.city && `${item?.city}`}
                  {item?.state && `, ${item?.state}`}
                  {item?.country?.name && `, ${item?.country.name}`}
                </div>
              </div>
            </div>
          </div>
          <div className="font-semibold flex justify-center items-center">
            {item?.rankings?.QS ?? "NA"}
          </div>
          <div className="font-semibold flex justify-center items-center">
            {item?.avgFeesUSD
              ? `USD ${item?.avgFeesUSD?.toLocaleString()}`
              : "NA"}
          </div>
          <div className="flex gap-2 justify-center items-center">
            {props?.selectedUni.includes(item?.id) ? (
              <MdOutlineCheckBox
                className="text-main text-[2em] cursor-pointer"
                onClick={() => {
                  props?.handleSelected(item?.id);
                }}
              />
            ) : (
              <MdOutlineCheckBoxOutlineBlank
                className="text-main text-[2em] cursor-pointer"
                onClick={() => {
                  props?.handleSelected(item?.id);
                }}
              />
            )}
            <BsBookmarkStarFill
              className={`${
                props?.watchlistedUnis.includes(item?.id)
                  ? "text-main"
                  : "text-gray-400"
              }  text-[1.75em] cursor-pointer`}
              onClick={() => {
                handleUniversityWishlist(item?.id);
              }}
            />
            <Link to={`/universities/${item?.id}`}>
              <img src={Images.RightArrowCircled} className="h-[2em]" />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecommenderTable;
